import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-footer-inner">
        <div className="footer-copy">© {new Date().getFullYear()} Aditya Electro Projects. All rights reserved.</div>
      </div>
    </footer>
  );
}

export default Footer;
